



















































































































import { Component, Vue } from 'vue-property-decorator'

interface TabelaOpcao {
  id: string
  nome: string
  tipoDeClienteNome: string
  tipoDeTabela: string
  vigencia: string
}

@Component
export default class DialogoSelecionarTabelasParaImportacao extends Vue {
	mostra = false

	tabelas: TabelaOpcao[] = []
	selecionadasIds: string[] = []
	textoBusca = ''

	get menuProps() {
		return { maxHeight: 4 * 40 + 56 }
	}

	get tabelasFiltradas(): TabelaOpcao[] {
		const busca = (this.textoBusca || '').trim().toLowerCase()

		if (!busca) return this.tabelas || []

		return (this.tabelas || []).filter(t => {
			const texto = [
				t.nome,
				t.tipoDeClienteNome,
				t.tipoDeTabela,
				t.vigencia,
			]
				.filter(Boolean)
				.join(' ')
				.toLowerCase()

			return texto.includes(busca)
		})
	}

	get tabelasSelecionadas(): TabelaOpcao[] {
		const selected = new Set(this.selecionadasIds || [])
		return (this.tabelas || [])
			.filter(t => selected.has(t.id))
			.slice()
			.sort(this.ordenarPorNome)
	}

	get todasSelecionadas() {
		const idsFiltrados = new Set((this.tabelasFiltradas || []).map(t => t.id))
		const selecionadasNoFiltro = (this.selecionadasIds || []).filter(id => idsFiltrados.has(id)).length

		return idsFiltrados.size > 0 && selecionadasNoFiltro === idsFiltrados.size
	}

	limparBusca() {
		this.textoBusca = ''
	}

	async limparComDelay() {
		setTimeout(() => {
			this.limparBusca()
		}, 1000)
	}

	isInativo(nome?: string) {
		const n = (nome || '').trim().toUpperCase()
		return n.startsWith('(INATIVO)') || n.startsWith('(INATIVA)') || n.startsWith('(INATIVADO)')
	}
	normalizarNome(nome?: string) {
		return (nome || '')
			.trim()
			.replace(/^\(inativa\)\s*/i, '')
			.replace(/^\(inativa \)\s*/i, '')
			.replace(/^\(inativado\)\s*/i, '')
			.trim()
	}

	ordenarPorNome(a: TabelaOpcao, b: TabelaOpcao) {
		const aInativo = this.isInativo(a.nome)
		const bInativo = this.isInativo(b.nome)

		if (aInativo !== bInativo) return aInativo ? 1 : -1

		const an = this.normalizarNome(a.nome)
		const bn = this.normalizarNome(b.nome)

		return an.localeCompare(bn, 'pt-BR', { sensitivity: 'base' })
	}

	selecionarTodas() {
		const atuais = new Set(this.selecionadasIds || [])
		for (const t of this.tabelasFiltradas || []) {
			atuais.add(t.id)
		}
		this.selecionadasIds = Array.from(atuais)

		this.$nextTick(() => {
			(this.$refs.autocompleteTabelas as any)?.blur()
		})
	}

	limparSelecao() {
		this.selecionadasIds = []

		this.$nextTick(() => {
			(this.$refs.autocompleteTabelas as any)?.blur()
		})
	}

	removerSelecionada(id: string) {
		this.selecionadasIds = (this.selecionadasIds || []).filter(x => x !== id)
	}

	mostrar(tabelas: TabelaOpcao[]) {
		this.tabelas = (tabelas || []).slice().sort(this.ordenarPorNome)
		this.selecionadasIds = []
		this.mostra = true
	}

	cancelar() {
		this.mostra = false
		this.selecionadasIds = []
		this.tabelas = []
	}

	confirmar() {
		this.$emit('confirmou', { tabelaIds: this.selecionadasIds })
		this.mostra = false
	}
}
